import React from "react";
import styled, { keyframes } from "styled-components";

/** 결과 페이지 '내 생각 습관' 막대 그래프. 가장 높은 습관을 강조합니다. */
export const TraitChart = ({ scores, traits, highlight, title = "내 생각 습관" }) => {
  if (!scores) return null;
  const max = Math.max(1, ...traits.map((t) => scores[t] || 0));

  return (
    <Wrap aria-label={`${title} 그래프`}>
      <Title>{title}</Title>
      {traits.map((t, i) => {
        const v = scores[t] || 0;
        return (
          <Row key={t} $on={t === highlight}>
            <Name>{t}</Name>
            <Track>
              <Fill style={{ width: `${(v / max) * 100}%`, animationDelay: `${i * 0.08}s` }} />
            </Track>
            <Value>{v}</Value>
          </Row>
        );
      })}
    </Wrap>
  );
};

const grow = keyframes`
  from { transform: scaleX(0); }
  to   { transform: scaleX(1); }
`;

const Wrap = styled.section`
  width: 100%;
  margin-top: 24px;
  padding: 18px 18px 14px;
  border: 1px solid #e6e6e6;
  border-radius: 16px;
`;

const Title = styled.div`
  margin-bottom: 12px;
  font-size: 15px;
  color: #555;
`;

const Row = styled.div`
  display: grid;
  grid-template-columns: 84px 1fr 24px;
  gap: 10px;
  align-items: center;
  padding: 5px 0;
  font-size: 14px;
  color: ${(p) => (p.$on ? "#1f2022" : "#888")};

  span:last-child {
    font-weight: ${(p) => (p.$on ? 700 : 400)};
  }
  div > div {
    background: ${(p) => (p.$on ? "#e8a33d" : "#d5d5d5")};
  }
`;

const Name = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const Track = styled.div`
  height: 10px;
  border-radius: 5px;
  background: #f2f2f2;
  overflow: hidden;
`;

const Fill = styled.div`
  height: 100%;
  border-radius: 5px;
  transform-origin: left;
  animation: ${grow} 0.8s cubic-bezier(0.2, 0.8, 0.2, 1) both;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;

const Value = styled.span`
  text-align: right;
  font-variant-numeric: tabular-nums;
`;
